<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header row -->
        <div class="row align-items-center py-3">
          <div class="col-md-6">
            <p class="appTitle mb-0">View Student Top College Admission Details</p>
          </div>
          <div class="col-md-6 text-end">
            <div class="admin-info d-inline-flex align-items-center">
              <span class="adminName me-2">{{ adminName }}</span>
              <img
                width="36"
                height="36"
               src="assets/tenant-avatar.jpg"
                class="rounded-circle"
                alt="Admin"
              />
            </div>
          </div>
        </div>

        <!-- Search box -->
        <div class="row my-4 justify-content-center">
          <div class="col-md-6">
            <div class="search-wrapper position-relative">
              <input
                class="form-control search-input"
                (input)="onQuickFilterChanged($event.target.value)"
                type="text"
                placeholder="🔍 Search admissions..."
                [(ngModel)]="searchval"
              />
              <!-- Clear button inside input -->
              <button
                type="button"
                class="clear-btn"
                *ngIf="searchval"
                (click)="reset()"
              >
                ✖
              </button>
            </div>
          </div>
        </div>

        <!-- AG Grid Table -->
        <div class="tableView my-5">
          <div class="ag-theme-alpine ag-table-custom">
            <ag-grid-angular
              #agGrid
              style="width: 100%; height: 650px;"
              class="ag-theme-alpine ag-table-custom"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [rowData]="rowData"
              [gridOptions]="gridOptions"
              [animateRows]="true"
              [pagination]="true"
              [paginationPageSize]="10"
              [paginationPageSizeSelector]="[10, 20, 50, 100]"
              (gridReady)="onGridReady($event)"
              rowSelection="single"
            >
            </ag-grid-angular>
          </div>
        </div>

        <!-- No data message -->
        <div class="noData text-center my-4" *ngIf="rowData?.length === 0">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>
    </div>
  </main>
</div>
